import './CertificateCard.scss';
import Subtitle from 'components/TextComps/Subtitle';
import Paragraph from 'components/TextComps/Paragraph';
import { CertificationTest, CertificationTestStatus, Prerequisite } from 'types/module';
import certLevel1Icon from 'images/Certification/cert_lvl_1.png';
import certLevel2Icon from 'images/Certification/cert_lvl_2.png';
import { ReactComponent as PadlockFilled } from 'images/icons/PadlockFilled.svg';
import { ReactComponent as Membership } from 'images/icons/MembershipFilled.svg';
import { ReactComponent as Document } from 'images/icons/DocumentThin.svg';
import { ReactComponent as Download } from 'images/icons/Download.svg';
import { Tooltip } from '@trackman/web-shared-components';
import { PrerequisitesTooltip } from './PrerequisitesTooltip/PrerequisitesTooltip';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { useServices } from 'index';

type CertificateCardProps = {
  title: string;
  status: CertificationTestStatus;
  description: string;
  prerequisites: Prerequisite[];
};
export const CertificateCard = ({ title, status, description, prerequisites }: CertificateCardProps) => {
  const { t } = useTranslation();
  const service = useServices().learningHubService;
  const hasPrerequisites = prerequisites?.length > 0;
  const certificateLinkClasses = !hasPrerequisites ? 'certification-link' : 'certification-link link-disabled';
  const downloadPdf = () => {
    const level = getCertificationLevel();
    service.download(level);
  };
  const getCertificationLevel = () =>
    title.toLowerCase().includes('level 1') ? 'level1' : title.toLowerCase().includes('level 2') ? 'level2' : '';

  return (
    <div className={status === 'Completed' ? 'certificate-card certificate-card__completed' : 'certificate-card'}>
      <a className={certificateLinkClasses}></a>
      <div className='header'>
        <img src={getCertificationLevel() === 'level1' ? certLevel1Icon : certLevel2Icon} />
        {status === 'Completed' && (
          <div className='completed-certificate'>
            <Membership /> <span>{t('Completed', { ns: 'learningHub' })}</span>
          </div>
        )}
      </div>

      <CertificationTitle title={title} status={status} prerequisites={prerequisites} />

      {status == 'Completed' ? (
        <Button className='download-button' startIcon={<Download />} onClick={downloadPdf}>
          {t('DownloadPDF', { ns: 'learningHub' })}
        </Button>
      ) : (
        <Paragraph>
          <>{description}</>
        </Paragraph>
      )}
    </div>
  );
};
type CertificationTitleProps = Pick<CertificationTest, 'title' | 'status' | 'prerequisites'>;

const CertificationTitle = ({ title, status, prerequisites }: CertificationTitleProps) => {
  const { t } = useTranslation();
  const hasPrerequisites = prerequisites?.length > 0;
  return (
    <>
      {status === 'Completed' ? (
        <div className='completed-title-wrapper'>
          <div className='file-type'>
            <Document />
            <div>PDF</div>
          </div>
          <div className='completed-title'>
            <Subtitle>
              <>{title}</>
            </Subtitle>
            <Paragraph>
              <>{t('DownloadYourCertificate', { ns: 'learningHub' })}</>
            </Paragraph>
          </div>
        </div>
      ) : (
        <div className={hasPrerequisites ? 'uncompleted-title-wrapper' : undefined}>
          {hasPrerequisites && (
            <Tooltip
              title={
                <div style={{ textAlign: 'center' }}>
                  <PrerequisitesTooltip prerequisitesTitles={prerequisites.map((p) => p.title)}></PrerequisitesTooltip>
                </div>
              }
              className='certificate-card-tooltip'
            >
              <PadlockFilled className='blocked-certificate-icon'></PadlockFilled>
            </Tooltip>
          )}
          <Subtitle className={hasPrerequisites ? 'title' : undefined}>
            <>{title}</>
          </Subtitle>
        </div>
      )}
    </>
  );
};
